import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { showMessage } from "store/misc/messageSlice";
import { showLoader, hideLoader } from "store/misc/loaderSlice";
import settingsService from "services/settingsService";

const initialState = {
	isSettingsLoading: false,
};

export const getSettings = createAsyncThunk(
	"store/fetchSettings",
	async (_, { dispatch }) => {
		try {
			dispatch(showLoader());
			dispatch(setSettingsLoading(true));
			const settings = await settingsService.get();
			return settings;
			// return { app_key: "$1$mJOn9xlE$cXn2NgtjbBf.SkP8.z9Yb." };
		} catch (error) {
			console.error(error);
			dispatch(
				showMessage({
					variant: "error",
					message: "Error occurred while getting store settings",
				})
			);
		} finally {
			dispatch(hideLoader());
			dispatch(setSettingsLoading(false));
		}
	}
);

const storeSlice = createSlice({
	name: "store",
	initialState,
	reducers: {
		setSettingsLoading: (state, action) => {
			state.isSettingsLoading = action.payload;
		},
	},
	extraReducers: {
		[getSettings.fulfilled]: (state, action) => {
			return {
				isSettingsLoading: false,
				...action.payload,
			};
		},
	},
});

export const { setSettingsLoading } = storeSlice.actions;
export default storeSlice.reducer;
